import React from "react";
import StoryLayout from "./StoryLayout";

export default function StoryCover() {
    return (
        <StoryLayout
            slideNumber={1}
            eyebrow="AudRI for ICF · A story"
            nextTo="/icf/story/setup"
            nextLabel="Show me"
            testid="story-cover"
        >
            <h1 className="heading text-4xl md:text-6xl font-medium tracking-tighter leading-[1.05] max-w-4xl">
                One amendment.
                <br />
                87 re-consents.
                <br />
                <span className="text-[#C2410C]">Hours instead of months.</span>
            </h1>
            <p className="text-[14px] md:text-[16px] text-neutral-600 mt-8 leading-relaxed max-w-2xl">
                A 90-second walkthrough of how AudRI would have handled
                Protocol Amendment v2.2 on{" "}
                <span className="mono text-[13px] text-neutral-700">ONCO-247</span>{" "}
                — a Phase II NSCLC study with 87 participants across 12 sites.
            </p>
            <p className="text-[12px] text-neutral-500 mt-6 italic">
                Self-paced. Click through at your own speed.
            </p>
        </StoryLayout>
    );
}
